/* eslint-disable unicorn/no-await-expression-member */
import React from 'react';

import {
  EmptyStateError,
  EmptyStateLoading,
  lazyLoad,
} from 'src/core/common/components/LazyLoad';

export const WalletContainer = lazyLoad({
  loader: async () => ({
    default: (
      await import(
        /* webpackChunkName: "WalletContainer" */ './WalletContainer'
      )
    ).WalletContainer,
  }),
  loading: <EmptyStateLoading />,
  fallback: (props) => <EmptyStateError {...props} />,
});
